import ManageWarehouseForm from '@/PageComponents/Warehouse/ManageWarehouseForm'
import Breadcrumbs from '@/components/breadcrumbs'
import SettingsMenu from '@/components/settings/menu'
import Router from "next/router"
import storeService from "@/services/store/store-service"
import { useEffect } from "react"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from '@tanstack/react-router'



const CreateWarehouse = () => {

  const { data: defaultStore } = useQuery(['defaultStore'], () => storeService.getDefaultStore());

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  return (
    <div className="settings-container">
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          {!!defaultStore &&
            <ManageWarehouseForm
              defaultStore={defaultStore}
              isNew={true}
            />
          }
        </div>
      </div>

      <style jsx>{`
        .column {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        .type-switch {
          position: absolute;
          top: 1.5rem;
          left: 580px;
        }
        a {
          text-decoration: none;
        }
      `}</style>
    </div>
  );
}

export default CreateWarehouse;

export const Route = createFileRoute('/_authenticated/settings/warehouse/create')({ component: CreateWarehouse })
